import * as React from 'react';

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var TamediaPaywall = (function (_super) {
    __extends(TamediaPaywall, _super);
    function TamediaPaywall() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TamediaPaywall.prototype.componentDidMount = function () {
        if (this.props.isEnabled) {
            var isInApp = new URL(window.location.href).searchParams.has('appwebview');
            if (isInApp) {
                console.debug('[Paywall] Is in app, not executing paywall component.');
                return;
            }
            if (process.env.NODE_ENV === 'development' ||
                navigator.userAgent === 'ReactSnap') {
                console.debug('[Paywall] In Development mode, not executing paywall component.');
                return;
            }
            var script = window.document.createElement('script');
            script.async = true;
            script.src =
                'https://interaktiv.tagesanzeiger.ch/static/config/paywall.js';
            window.document.body.appendChild(script);
            var isPremium = this.props.paywallConfiguration.doc_type === 'premium';
            window._dsc = window._dsc || [];
            window._dsc.push(['abo', isPremium]);
        }
    };
    TamediaPaywall.prototype.render = function () {
        return null;
    };
    return TamediaPaywall;
}(React.Component));

export { TamediaPaywall as Paywall, TamediaPaywall as default };
//# sourceMappingURL=index.js.map
